import amplitude, {AmplitudeClient} from 'amplitude-js';

const {REACT_APP_AMPLITUDE_CLIENT_ID} = process.env;

const client: AmplitudeClient = amplitude.getInstance();
client.init(REACT_APP_AMPLITUDE_CLIENT_ID ?? "88317c5f4791c8bec84ab09df694fcea");

export {client}
